import Vue from "vue";
import VueRouter from "vue-router";
import store from '../store';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    // 홈
    {
      path: "/",
      name: "home",
      component: () => import(/* webpackChunkName: "home" */ "../views/Home/Main")
    },

    // 인증 관련
    {
      path: "/signup",
      name: "회원가입",
      component: () => import(/* webpackChunkName: "auth" */ "../views/Sign/Main")
    },
    {
      path: "/signup/:code",
      name: "회원가입_추천인",
      component: () => import(/* webpackChunkName: "auth" */ "../views/Sign/MainReffer")
    },
    {
      path: "/login",
      name: "로그인",
      component: () => import(/* webpackChunkName: "auth" */ "../views/Login/Main")
    },
    {
      path: "/resend",
      name: "인증메일 다시보내기",
      component: () => import(/* webpackChunkName: "auth" */ "../views/Resend/Main")
    },
    {
      path: "/forget",
      name: "비밀번호 찾기",
      component: () => import(/* webpackChunkName: "auth" */ "../views/Forget/Main")
    },
    {
      path: "/password/:code",
      name: "비밀번호 변경",
      component: () => import(/* webpackChunkName: "auth" */ "../views/Password/Main")
    },
    {
      path: "/phone/:code",
      name: "휴대폰 인증",
      component: () => import(/* webpackChunkName: "auth" */ "../views/Phone/Main")
    },

    // 메인 기능
    {
      path: "/reservation",
      name: "예약관리",
      component: () => import(/* webpackChunkName: "main" */ "../views/Schedule/Main")
    },
    {
      path: "/notice",
      name: "알림",
      component: () => import(/* webpackChunkName: "main" */ "../views/Notice/Main")
    },
    {
      path: "/request",
      name: "요청",
      component: () => import(/* webpackChunkName: "main" */ "../views/Request/Main")
    },
    {
      path: "/sales",
      name: "매출",
      component: () => import(/* webpackChunkName: "main" */ "../views/Sales/Main")
    },
    {
      path: "/statistics",
      name: "통계",
      component: () => import(/* webpackChunkName: "main" */ "../views/Statistics/Main")
    },

    // 고객 관리
    {
      path: "/client",
      name: "고객관리",
      component: () => import(/* webpackChunkName: "client" */ "../views/Client/List")
    },
    {
      path: "/client/add",
      name: "고객 추가",
      component: () => import(/* webpackChunkName: "client" */ "../views/Client/Add")
    },
    {
      path: "/group/add",
      name: "그룹 추가",
      component: () => import(/* webpackChunkName: "group" */ "../views/Group/Add")
    },
    {
      path: "/group/edit/:code",
      name: "그룹 수정",
      component: () => import(/* webpackChunkName: "group" */ "../views/Group/Edit")
    },
    {
      path: "/group/detail/:code",
      name: "그룹 상세정보",
      component: () => import(/* webpackChunkName: "group" */ "../views/Group/Detail")
    },
    {
      path: "/group/document/send/:code",
      name: "그룹 문서보내기",
      component: () => import(/* webpackChunkName: "group" */ "../views/Group/DocumentSend")
    },
    {
      path: "/group/document/success/:code",
      name: "그룹 문서 성공",
      component: () => import(/* webpackChunkName: "group" */ "../views/Group/DocumentSuccess")
    },
    {
      path: "/group/detail/:code/:date",
      name: "그룹 상세 PDF",
      component: () => import(/* webpackChunkName: "client" */ "../views/Group/PDF")
    },
    {
      path: "/client/excel",
      name: "고객 추가엑셀",
      component: () => import(/* webpackChunkName: "client" */ "../views/Client/ExcelAdd")
    },
    {
      path: "/client/detail/:code",
      name: "고객 상세",
      component: () => import(/* webpackChunkName: "client" */ "../views/Client/Detail")
    },
    
    {
      path: "/client/detail/:code/:date",
      name: "고객 상세 PDF",
      component: () => import(/* webpackChunkName: "client" */ "../views/Client/PDF")
    },
    {
      path: "/client/edit/:code",
      name: "고객 수정",
      component: () => import(/* webpackChunkName: "client" */ "../views/Client/Edit")
    },

    // 고객 문서 관련
    {
      path: "/client/document/send/:code",
      name: "고객 문서 전송",
      component: () => import(/* webpackChunkName: "client-document" */ "../views/Client/DocumentSend")
    },
    {
      path: "/client/document/success/:code",
      name: "고객 문서 전송 성공",
      component: () => import(/* webpackChunkName: "client-document" */ "../views/Client/DocumentSuccess")
    },
    {
      path: "/client/form/detail/:code/:no",
      name: "고객 폼 확인",
      component: () => import(/* webpackChunkName: "client-document" */ "../views/Client/FormDetail")
    },
    {
      path: "/client/document/detail/:code/:no",
      name: "고객 문서 확인",
      component: () => import(/* webpackChunkName: "client-document" */ "../views/Client/DocumentDetail")
    },
    {
      path: "/client/question/detail/:code/:no",
      name: "고객 질문지 확인",
      component: () => import(/* webpackChunkName: "client-document" */ "../views/Client/QuestionDetail")
    },
    {
      path: "/client/pledge/detail/:code/:no",
      name: "고객 서약서 확인",
      component: () => import(/* webpackChunkName: "client-document" */ "../views/Client/PledgeDetail")
    },
    {
      path: "/client/assessment/detail/:code/:no",
      name: "고객 검사지 확인",
      component: () => import(/* webpackChunkName: "client-document" */ "../views/Client/AssessmentDetail")
    },
    {
      path: "/client/assessment/gui/detail/:code/:no",
      name: "가이던스 고객 검사지 확인",
      component: () => import(/* webpackChunkName: "client-document" */ "../views/Client/GuiAssessmentDetail")
    },
    {
      path: "/client/simple/detail/:code/:no",
      name: "고객 간편 예약 확인",
      component: () => import(/* webpackChunkName: "client-document" */ "../views/Client/SimpleDetail")
    },

    // 고객 1:1 문의
    {
      path: "/client/direct/send/new/:code",
      name: "고객 1:1 문의 전송",
      component: () => import(/* webpackChunkName: "client-direct" */ "../views/Client/DirectSendNew")
    },
    {
      path: "/client/direct/send/reply/:code/:gcode",
      name: "고객 1:1 문의 답변 전송",
      component: () => import(/* webpackChunkName: "client-direct" */ "../views/Client/DirectSendReply")
    },
    {
      path: "/client/direct/success/:code",
      name: "고객 1:1 문의 답변 전송 완료",
      component: () => import(/* webpackChunkName: "client-direct" */ "../views/Client/DirectSuccess")
    },

    // 설정
    {
      path: "/setting",
      name: "설정",
      component: () => import(/* webpackChunkName: "setting" */ "../views/Setting/Main")
    },
    {
      path: "/setting/myInfo",
      name: "내 정보",
      component: () => import(/* webpackChunkName: "setting" */ "../views/Setting/MyInfo")
    },
    {
      path: "/setting/remove",
      name: "계정 삭제",
      component: () => import(/* webpackChunkName: "setting" */ "../views/Setting/Remove")
    },
    {
      path: "/setting/alarm",
      name: "알람 설정",
      component: () => import(/* webpackChunkName: "setting" */ "../views/Setting/Alarm")
    },
    {
      path: "/setting/changePlan",
      name: "요금제 변경하기",
      component: () => import(/* webpackChunkName: "setting" */ "../views/Setting/ChangePlan")
    },
    {
      path: "/setting/changePlanS",
      name: "요금제 변경",
      component: () => import(/* webpackChunkName: "setting" */ "../views/Setting/ChangePlanStudent")
    },

    // 설정 - 프로그램 관리
    {
      path: "/setting/program",
      name: "프로그램 관리",
      component: () => import(/* webpackChunkName: "setting-program" */ "../views/Setting/Program")
    },
    {
      path: "/admin/place",
      name: "장소 관리",
      component: () => import(/* webpackChunkName: "setting-place" */ "../views/Setting/Place")
    },

    // 설정 - 문서 관리
    {
      path: "/setting/document",
      name: "문서 관리",
      component: () => import(/* webpackChunkName: "setting-document" */ "../views/Setting/DocumentMain")
    },
    {
      path: "/setting/document/new",
      name: "동의서 추가",
      component: () => import(/* webpackChunkName: "setting-document" */ "../views/Setting/DocumentAdd")
    },
    {
      path: "/setting/document/detail/:no",
      name: "동의서 상세",
      component: () => import(/* webpackChunkName: "setting-document" */ "../views/Setting/DocumentDetail")
    },
    {
      path: "/setting/document/edit/:no",
      name: "동의서 수정",
      component: () => import(/* webpackChunkName: "setting-document" */ "../views/Setting/DocumentEdit")
    },

    // 설정 - 질문지 관리
    {
      path: "/setting/question/new",
      name: "질문지 추가",
      component: () => import(/* webpackChunkName: "setting-question" */ "../views/Setting/QuestionAdd")
    },
    {
      path: "/setting/question/detail/:no",
      name: "질문지 상세",
      component: () => import(/* webpackChunkName: "setting-question" */ "../views/Setting/QuestionDetail")
    },
    {
      path: "/setting/question/edit/:no",
      name: "질문지 수정",
      component: () => import(/* webpackChunkName: "setting-question" */ "../views/Setting/QuestionEdit")
    },

    // 설정 - 서약서 관리
    {
      path: "/setting/pledge/new",
      name: "서약서 추가",
      component: () => import(/* webpackChunkName: "setting-pledge" */ "../views/Setting/PledgeAdd")
    },
    {
      path: "/setting/pledge/detail/:no",
      name: "서약서 상세",
      component: () => import(/* webpackChunkName: "setting-pledge" */ "../views/Setting/PledgeDetail")
    },
    {
      path: "/setting/pledge/edit/:no",
      name: "서약서 수정",
      component: () => import(/* webpackChunkName: "setting-pledge" */ "../views/Setting/PledgeEdit")
    },

    // 설정 - 상담일지 관리
    {
      path: "/setting/record",
      name: "상담일지 관리",
      component: () => import(/* webpackChunkName: "setting-record" */ "../views/Setting/RecordMain")
    },
    {
      path: "/setting/record/new",
      name: "상담일지 추가",
      component: () => import(/* webpackChunkName: "setting-record" */ "../views/Setting/RecordAdd")
    },
    {
      path: "/setting/record/detail/:no",
      name: "상담일지 상세",
      component: () => import(/* webpackChunkName: "setting-record" */ "../views/Setting/RecordDetail")
    },
    {
      path: "/setting/record/edit/:no",
      name: "상담일지 수정",
      component: () => import(/* webpackChunkName: "setting-record" */ "../views/Setting/RecordEdit")
    },

    // 설정 - 보고서 관리
    {
      path: "/setting/report/new",
      name: "보고서 / 소견서 추가",
      component: () => import(/* webpackChunkName: "setting-report" */ "../views/Setting/ReportAdd")
    },
    {
      path: "/setting/report/detail/:no",
      name: "보고서 / 소견서 상세",
      component: () => import(/* webpackChunkName: "setting-report" */ "../views/Setting/ReportDetail")
    },
    {
      path: "/setting/report/edit/:no",
      name: "보고서 / 소견서 수정",
      component: () => import(/* webpackChunkName: "setting-report" */ "../views/Setting/ReportEdit")
    },

    // 설정 - 간편예약
    {
      path: "/admin/simple",
      name: "간편예약관리",
      component: () => import(/* webpackChunkName: "setting" */ "../views/Setting/Simple")
    },

    // 설정 - 테스트
    {
      path: "/setting/test",
      name: "TEXT",
      component: () => import(/* webpackChunkName: "setting" */ "../views/Setting/TEST")
    },
    {
      path: "/setting/integration",
      name: "화상상담 연동",
      component: () => import(/* webpackChunkName: "setting-intergration" */ "../views/Setting/Intergration")
    },
    // 알람
    {
      path: "/alarm",
      name: "알람",
      component: () => import(/* webpackChunkName: "alarm" */ "../views/Alarm/Main")
    },
    {
      path: "/alarm/notice/add",
      name: "알람 추가",
      component: () => import(/* webpackChunkName: "alarm" */ "../views/Alarm/NoticeAdd")
    },

    // 관리자 기능
    {
      path: "/admin",
      name: "관리자 설정",
      component: () => import(/* webpackChunkName: "admin" */ "../views/Admin/Main")
    },
    {
      path: "/admin/center",
      name: "센터 정보 관리",
      component: () => import(/* webpackChunkName: "admin" */ "../views/Admin/CenterInfo")
    },
    {
      path: "/admin/ip",
      name: "에피 접속IP 제한",
      component: () => import(/* webpackChunkName: "admin" */ "../views/Admin/CenterIP")
    },
    {
      path: "/admin/alarm",
      name: "에피 센터 알림",
      component: () => import(/* webpackChunkName: "admin" */ "../views/Admin/CenterAlarm")
    },
    {
      path: "/admin/charge",
      name: "에피 알림 충전",
      component: () => import(/* webpackChunkName: "admin" */ "../views/Admin/CenterCharge")
    },
    {
      path: "/admin/export",
      name: "데이터 내보내기",
      component: () => import(/* webpackChunkName: "admin" */ "../views/Admin/Export")
    },
    {
      path: "/admin/cash",
      name: "캐시 충전",
      component: () => import(/* webpackChunkName: "admin" */ "../views/Admin/Cash")
    },
    {
      path: "/admin/payout",
      name: "정산 관리",
      component: () => import(/* webpackChunkName: "admin" */ "../views/Admin/Payout")
    },
    {
      path: "/admin/decode",
      name: "암호화",
      component: () => import(/* webpackChunkName: "admin" */ "../views/Admin/Decode")
    },
    {
      path: "/admin/integration",
      name: "화상상담 연동",
      component: () => import(/* webpackChunkName: "admin" */ "../views/Admin/CenterIntergration")
    },
    {
      path: "/admin/room",
      name: "상담실 관리",
      component: () => import(/* webpackChunkName: "admin" */ "../views/Admin/CenterRoom")
    },

    // 팀원 관리
    {
      path: "/admin/team",
      name: "팀원 관리",
      component: () => import(/* webpackChunkName: "admin-team" */ "../views/Admin/TeamList")
    },
    {
      path: "/admin/team/add",
      name: "팀원추가",
      component: () => import(/* webpackChunkName: "admin-team" */ "../views/Admin/TeamAdd")
    },
    {
      path: "/admin/team/detail/:code",
      name: "팀원상세",
      component: () => import(/* webpackChunkName: "admin-team" */ "../views/Admin/TeamDetail")
    },
    // 설정 - 간편예약
    {
      path: "/admin/weeclass",
      name: "위클래스 관리",
      component: () => import(/* webpackChunkName: "admin-weclass" */ "../views/Admin/WeClass")
    },
    // 설정 - 간편예약
    {
      path: "/admin/weeclass/add",
      name: "위클래스 추가",
      component: () => import(/* webpackChunkName: "admin-weclass" */ "../views/Admin/WeClassAdd")
    },
    // 결제
    {
      path: "/payment/:center_code",
      name: "결제",
      component: () => import(/* webpackChunkName: "payment" */ "../views/Payment/Main")
    },
    {
      path: "/payment/:center_code/ChangePlan",
      name: "결제-요금제 변경",
      component: () => import(/* webpackChunkName: "payment" */ "../views/Payment/PlanChange")
    },
    {
      path: "/payment/:center_code/remove",
      name: "결제-계정삭제",
      component: () => import(/* webpackChunkName: "payment" */ "../views/Payment/Remove")
    },
    {
      path: "/plan/change/:center_code/:plan/:team_count",
      name: "결제성공",
      component: () => import(/* webpackChunkName: "payment" */ "../views/Payment/PlanMobile")
    },

    // 외부 서비스 연동
    {
      path: "/zoom",
      name: "줌 연동",
      component: () => import(/* webpackChunkName: "integration" */ "../views/Zoom/Main")
    },
    {
      path: "/google",
      name: "구글 연동",
      component: () => import(/* webpackChunkName: "integration" */ "../views/Google/Main")
    },

    // 축어록
    {
      path: "/translation",
      name: "축어록",
      component: () => import(/* webpackChunkName: "translation" */ "../views/Setting/Translation")
    },
    {
      path: "/translation/new/:code",
      name: "축어록 작성",
      component: () => import(/* webpackChunkName: "translation" */ "../views/Setting/TranslationNew")
    },
    {
      path: "/translation/detail/:code",
      name: "축어록 상세",
      component: () => import(/* webpackChunkName: "translation" */ "../views/Setting/TranslationDetail")
    },
    {
      path: "/translation/edit/:code",
      name: "축어록 수정",
      component: () => import(/* webpackChunkName: "translation" */ "../views/Setting/TranslationEdit")
    },
    {
      path: "/translation/original/:code",
      name: "원본 보기",
      component: () => import(/* webpackChunkName: "translation" */ "../views/Setting/TranslationOrignal")
    },
    {
      path: "/translation/original/word/:code",
      name: "원본 보기 WORD",
      component: () => import(/* webpackChunkName: "translation" */ "../views/Setting/TranslationOrignalWord")
    },
    {
      path: "/translation/original/pdf/:code",
      name: "원본 보기 PDF",
      component: () => import(/* webpackChunkName: "translation" */ "../views/Setting/TranslationOrignalPdf")
    },
    {
      path: "/translation/detail/word/:code",
      name: "축어록 보기 WORD",
      component: () => import(/* webpackChunkName: "translation" */ "../views/Setting/TranslationDetailWord")
    },
    {
      path: "/translation/detail/pdf/:code",
      name: "축어록 보기 PDF",
      component: () => import(/* webpackChunkName: "translation" */ "../views/Setting/TranslationDetailPdf")
    },

    // 기타
    {
      path: "/mailing/link/:code",
      name: "메일링",
      component: () => import(/* webpackChunkName: "misc" */ "../views/Mailing/Link")
    }
  ]
});

router.beforeEach((to, from, next) => {
  let reset_list = false;

  if (!to.path.includes('client')) {
    if (!to.path.includes('group')) {
      reset_list = true;  
    }
  }

  if(reset_list){
    store.dispatch('RESETMEMBERLIST');
    store.dispatch('RESETGROUPLIST');
    store.dispatch('CLIENTTABCHANGE','C');
  }
  
  next();
});

export default router;